import api from '../utils/api';

export const login = (data) => {
  return api().post('/login', data);
};

export const logout = (data) => {
  return api().post('/logout', data);
};
